<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block"> Edit Scenario "{{scenarioid}}"</h1>
  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray;margin-top:-10px" (click)="showinfo = !showinfo"></i>
  <button class="btn btn-primary" (click)="save()" style="float:right;margin-top:10px">Save</button>
  <br>
  <div *ngIf="showinfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    A Scenario defines all assets (components, ground, skybox) and camera configuration for a virtual experience.
  </div>

  <div>
    <ul class="nav nav-tabs" id="myTab2" role="tablist">
      <li class="nav-item" role="presentation">
        <a class="nav-link active" id="header-tab" data-bs-toggle="tab" href="#header" role="tab" aria-controls="header" aria-selected="true">Header</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="components-tab" data-bs-toggle="tab" href="#components" role="tab" aria-controls="components" aria-selected="true">Components</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="lessonplan-tab" data-bs-toggle="tab" href="#lessonplan" role="tab" aria-controls="lessonplan" aria-selected="true">Lesson Plan</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="interactivities-tab" data-bs-toggle="tab" href="#interactivities" role="tab" aria-controls="interactivities" aria-selected="true">Interactivities</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="modifiers-tab" data-bs-toggle="tab" href="#modifiers" role="tab" aria-controls="modifiers" aria-selected="true">Modifiers</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="ground-tab" data-bs-toggle="tab" href="#ground" role="tab" aria-controls="ground" aria-selected="true">Ground</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="lighting-tab" data-bs-toggle="tab" href="#lighting" role="tab" aria-controls="lighting" aria-selected="false">Lighting</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="fog-tab" data-bs-toggle="tab" href="#fog" role="tab" aria-controls="fog" aria-selected="false">Fog</a>
      </li>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="skybox-tab" data-bs-toggle="tab" href="#skybox" role="tab" aria-controls="skybox" aria-selected="false">Skybox</a>
      <li class="nav-item" role="presentation">
        <a class="nav-link" id="json-tab" data-bs-toggle="tab" href="#json" role="tab" aria-controls="json" aria-selected="false">JSON</a>
      </li>
    </ul>


    <!-- Content of  Tabs -------------------------------------------------------------------------->
    <div class="tab-content" id="myTab2Content">
      <!-- Header -------------------------------------------------------------------------->
      <div class="tab-pane active fade show" id="header" role="tabpanel" aria-labelledby="header-tab">
        <h5>Header</h5>

        <div class="inline"><sa-label [title]="'Name (of node) = id'" [(text)]="scenarioid"></sa-label></div>
        <div class="inline"><sa-input-text [(text)]="scenario.displayName" [title]="'Display Name' "></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="scenario.seqNo" [title]="'Sequence Number'"></sa-input-number></div>
        <div class="inline"><sa-input-text [(text)]="scenario.institute" [title]="'Institute'"></sa-input-text></div>
        <div class="inline"><sa-input-text [(text)]="scenario.owner" [title]="'Owner'"></sa-input-text></div>
        <div class="inline"><sa-input-text [(text)]="scenario.status" [title]="'Status'"></sa-input-text></div>
        <br>
        <div class="inline"><sa-select [(Id)]="cameraConfigId" [title]="'Camera Config'" [options]="cameraConfigs"></sa-select></div>

        <div class="inline"><sa-input-boolean [(checked)]="scenario.showAxis" [title]="'Show Axis'"></sa-input-boolean></div>

        <div class="inline"><sa-input-boolean [(checked)]="scenario.doPerformanceLogging" [title]="'doPerformanceLogging'"></sa-input-boolean></div>
        <div class="inline"><sa-input-boolean [(checked)]="scenario.isVersion2" [title]="'isVersion2'"></sa-input-boolean></div>
        <div class="inline"><sa-input-boolean [(checked)]="scenario.forceAssetRefresh" [title]="'forceAssetRefresh'"></sa-input-boolean></div>
        <div class="inline"><sa-input-boolean [(checked)]="scenario.doLogAssetSizes" [title]="'doLogAssetSizes'"></sa-input-boolean></div>
        <div class="inline"><sa-input-boolean [(checked)]="scenario.enablePanelPad" [title]="'enablePanelPad'"></sa-input-boolean></div>
        <div class="inline"><sa-input-boolean [(checked)]="scenario.hasInventory" [title]="'hasInventory'"></sa-input-boolean></div>

        <div style="padding-left:20px;margin-top:20px">Start and endpoints of character staging area</div>
        <div class="inline"><sa-input-number [(text)]="scenario.stagingX0" [title]="'x0' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.stagingY0" [title]="'y0' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.stagingX1" [title]="'x1' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.stagingY1" [title]="'y1' "></sa-input-number></div>

        <div style="padding-left:20px;margin-top:20px">Initial direction of player</div>
        <div class="inline"><sa-input-number [(text)]="scenario.angle0" [title]="'angle0'"></sa-input-number></div>
        <small class="text-muted" style="display:block;padding-left:20px">Initial angle of player in degrees (0 = facing +z)</small>
        <div style="max-width:600px;margin-top:20px"><sa-input-textarea [(text)]="scenario.description" [title]="'Description'"></sa-input-textarea></div>
      </div>

      <!-- components -------------------------------------------------------------------------->
      <div *ngIf="scenario?.components" class="tab-pane fade show" id="components" role="tabpanel" aria-labelledby="header-tab">
        <h5 style="display:inline-block">Components</h5>
        <button class="btn btn-primary" (click)="addComponent(null)" style="float:right;margin-top:10px;margin-bottom:10px">Add Component</button>
        <br>
        <div style="max-height: 500px; overflow-y: auto;">
          <table class="table table-bordered">
            <thead style="position: sticky; top: 0; background-color: white; z-index: 1;">
              <tr>
                <th>Id <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortComponentBy('id')"></i></th>
                <th>Enabled</th>
                <th>Edit</th>
                <th>Name <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortComponentBy('name')"></i></th>
                <th>File <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortComponentBy('file')"></i></th>
                <th>PosX</th>
                <th>PosY</th>
                <th>PosZ</th>
                <th>RotX</th>
                <th>RotY</th>
                <th>RotZ</th>
                <th>Scale</th>
                <th>CheckCOllision</th>
                <th>IsPickable</th>
                <th>IsVisible</th>
                <th>IsWalkable</th>
                <th>Delete</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let c of scenario.components">
                <td>{{c.id}}</td>
                <td><input type="checkbox" [(ngModel)]="c.enabled"></td>
                <td><i class="bi bi-pencil" style="color:green" (click)="addComponent(c)"></i></td>
                <td>{{c.name}}</td>
                <td>{{c.file}}</td>
                <td>{{c.posX | number:'1.0-2'}}</td>
                <td>{{c.posY | number:'1.0-2'}}</td>
                <td>{{c.posZ | number:'1.0-2'}}</td>
                <td>{{c.rotX | number:'1.0-2'}}</td>
                <td>{{c.rotY | number:'1.0-2'}}</td>
                <td>{{c.rotZ | number:'1.0-2'}}</td>
                <td>{{c.scale}}</td>
                <td>{{c.checkCollisions}}</td>
                <td>{{c.isPickable}}</td>
                <td>{{c.isVisible}}</td>
                <td>{{c.isWalkable}}</td>
                <td><i class="bi bi-trash" style="color:orange" (click)="deleteComponent(c)"></i></td>

              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <!-- Lessonplan -------------------------------------------------------------------------->
      <div *ngIf="scenario?.lessonplan" class="tab-pane fade show" id="lessonplan" role="tabpanel" aria-labelledby="header-tab">
        <app-lessonplan [scenario]="scenario" [saveFn]="save.bind(this)" [reloadFn]="getData.bind(this)"></app-lessonplan>
      </div>

      <!-- Interactivities -------------------------------------------------------------------------->
      <div *ngIf="scenario?.interactivities" class="tab-pane fade show" id="interactivities" role="tabpanel" aria-labelledby="header-tab">
        <app-interactivities [scenario]="scenario" [onSaveInteractivity]="save.bind(this)" [onReloadInteractivity]="getData.bind(this)"></app-interactivities>
      </div>

      <!-- Modifiers -------------------------------------------------------------------------->
      <div *ngIf="scenario?.modifiers" class="tab-pane fade show" id="modifiers" role="tabpanel" aria-labelledby="header-tab">
        <app-modifiers [scenario]="scenario" [saveFn]="save.bind(this)" [reloadFn]="getData.bind(this)"></app-modifiers>
      </div>

      <!-- ground -------------------------------------------------------------------------->
      <div *ngIf="scenario?.ground" class="tab-pane fade show" id="ground" role="tabpanel" aria-labelledby="header-tab">
        <h5 style="display:inline-block">Ground</h5>
        <button class="btn btn-info" style="margin-left: 10px;" (click)="showGroundInfo = !showGroundInfo">
          <i class="bi bi-info-circle"></i> Info
        </button>
        <div *ngIf="showGroundInfo" style="margin:20px 0;padding:15px;background-color:#e3f2fd;border:1px solid #90caf9;border-radius:5px;">
          <h5>Ground Creation</h5>
          The ground is created using the selected method and the specified parameters.
          <p><b>Method Options:</b></p>
          <ul>
            <li><b>createStandardGround</b>: Creates a standard ground mesh using the "File Name (Diffuse)" texture.</li>
            <li><b>createGroundWithRandomTiles</b>: tiles the "File Name (Diffuse)" in a random orientation to avoid repetition patterns.</li>
            <li><b>createPBRGround</b>: Creates a ground mesh with Physically Based Rendering (PBR) materials.
              It needs the following Files
              <ul>
                <li><b>File Name (Diffuse)</b>: The main texture for the ground.</li>
                <li><b>File Name (Roughness)</b>: The roughness texture for PBR.</li>
                <li><b>File Name (Normal)</b>: The normal map texture for PBR.</li>
                <li><b>File Name (Displacement)</b>: The displacement map texture for PBR.</li>
              </ul>
            </li>
          </ul>
          <b>Terrain (Height Map):</b> In addition,if a height map (gray scale image) is provided in the "Terrain" field, it will be used to create terrain elevations.
          The height map will be scaled according to the"Max Height" parameters.
          <br><br>
          Width and Height is in meters. Subdivisions are in both direction.
          <br>
          <b>If in doubt, check the GroundHandler implementation of Virtex</b>
        </div>
        <br>
        <div class="inline"><sa-select [(Id)]="groundMethodId" [title]="'Method Name'" [options]="groundMethods"></sa-select></div>
        <div class="inline"><sa-input-number [(text)]="scenario.ground.width" [title]="'Width' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.ground.height" [title]="'Height' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.ground.subdivisions" [title]="'Subdivisions' "></sa-input-number></div>
        <br><br>
        <div style="margin-left:10px">
          <div style="width: 400px;"><sa-input-text [(text)]="scenario.ground.fileName" [title]="'File Name (Diffuse, always needed)' "></sa-input-text></div>
          <div style="width: 400px;"><sa-input-text [(text)]="scenario.ground.normalFileName" [title]="'Normal File Name (optional)' "></sa-input-text></div>
          <div style="width: 400px;"><sa-input-text [(text)]="scenario.ground.roughnessFileName" [title]="'Roughness File Name (PBR)' "></sa-input-text></div>
          <div style="width: 400px;"><sa-input-text [(text)]="scenario.ground.displacementFileName" [title]="'Displacement File Name (PBR)' "></sa-input-text></div>
        </div>
        <div class="inline" style="width: 400px;"><sa-input-text [(text)]="scenario.ground.terrain" [title]="'Terrain (optional)' "></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="scenario.ground.maxHeight" [title]="'Max Height' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.ground.extensionYOffset" [title]="'Extension Y Offset' "></sa-input-number></div>
      </div>

      <!-- lighting -------------------------------------------------------------------------->
      <div  class="tab-pane fade" id="lighting" role="tabpanel" aria-labelledby="lighting-tab">
        <h5>Lighting</h5>
        <div style="width: 400px;"><sa-select [(Id)]="lightingMethodId" [title]="'Method Name'" [options]="lightingMethods"></sa-select></div>
      </div>

      <!-- fog -------------------------------------------------------------------------->
      <div class="tab-pane fade" id="fog" role="tabpanel" aria-labelledby="fog-tab">
        <h5>Fog</h5>
        <div style="width: 400px;"><sa-select [(Id)]="fogMethodId" [title]="'Method Name'" [options]="fogMethods"></sa-select></div>
        <div style="width: 400px;"><sa-select [(Id)]="fogColorId" [title]="'Fog Color'" [options]="fogColors"></sa-select></div>
      </div>

      <!-- skybox -------------------------------------------------------------------------->
      <div *ngIf="scenario?.skybox" class="tab-pane fade show" id="skybox" role="tabpanel" aria-labelledby="header-tab">
        <h5>Skybox</h5>
        <div style="width: 400px;"><sa-input-text [(text)]="scenario.skybox.reflectionTexture" [title]="'ReflectionTexture' "></sa-input-text></div>
        <div class="inline"><sa-input-number [(text)]="scenario.skybox.size" [title]="'Size' "></sa-input-number></div>
        <div class="inline"><sa-input-number [(text)]="scenario.skybox.posy" [title]="'PosY' "></sa-input-number></div>
      </div>

      <!-- json -------------------------------------------------------------------------->
      <div class="tab-pane fade show" id="json" role="tabpanel" aria-labelledby="header-tab">
        <h5>JSON</h5>
        <pre>{{ scenario | json }}</pre>
      </div>
    </div>
  </div>
</div>

<!-- Modal ----------------------------------------------->
<div *ngIf="showComponentModal" #testmodal class="cpmodal">
  <div class="cpmodal-content" style="width:1200px">
    <div class="cpmodal-header">
      Component {{component.id}}
    </div>
    <div class="inline"><sa-input-text [(text)]="component.id" [title]="'Unique Id' "></sa-input-text></div>
    <div class="inline"><sa-input-text [(text)]="component.file" [title]="'File' "></sa-input-text></div>
    <div class="inline"><sa-input-text [(text)]="component.name" [title]="'Name' "></sa-input-text></div>

    <div class="inline"><sa-select [(Id)]="componentModelTypeId" [title]="'Scenario'" [options]="ComponentModelTypes"></sa-select></div>
    <div class="inline"><sa-input-text [(text)]="component.type" [title]="'Type' "></sa-input-text></div>
    <div class="inline"><sa-input-boolean [(checked)]="component.checkCollisions" [title]="'Check Collisions' "></sa-input-boolean></div>
    <div class="inline"><sa-input-boolean [(checked)]="component.enabled" [title]="'Enabled' "></sa-input-boolean></div>
    <div class="inline"><sa-input-boolean [(checked)]="component.isPickable" [title]="'Is Pickable' "></sa-input-boolean></div>
    <div class="inline"><sa-input-boolean [(checked)]="component.isVisible" [title]="'Is Visible' "></sa-input-boolean></div>
    <div class="inline"><sa-input-boolean [(checked)]="component.isWalkable" [title]="'Is Walkable' "></sa-input-boolean></div>

    <div class="spacer10"></div>
    <div class="inline"><sa-input-number [(text)]="component.posX" [title]="'PosX' "></sa-input-number></div>
    <div class="inline"><sa-input-number [(text)]="component.posY" [title]="'PosY' "></sa-input-number></div>
    <div class="inline"><sa-input-number [(text)]="component.posZ" [title]="'PosZ' "></sa-input-number></div>

    <div class="spacer10"></div>
    <div class="inline"><sa-input-number [(text)]="component.rotX" [title]="'rotX' "></sa-input-number></div>
    <div class="inline"><sa-input-number [(text)]="component.rotY" [title]="'rotY' "></sa-input-number></div>
    <div class="inline"><sa-input-number [(text)]="component.rotZ" [title]="'rotZ' "></sa-input-number></div>

    <div class="spacer10"></div>
    <div class="inline"><sa-input-number [(text)]="component.scale" [title]="'Scale' "></sa-input-number></div>

    <div class="spacer10"></div>
    <button class="btn btn-primary" (click)="updateComponent()">Update Component</button>
    <button class="btn btn-primary" style="float:right" (click)="showComponentModal = false">Cancel</button>
    <div class="spacer10"></div>
    <br>{{component | json}}
  </div>
</div>

<!-- Modal Component Property ----------------------------------------------->
<div *ngIf="showComponentPropertyModal" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">
      Choose a new unique name for the scenario
    </div>
    <div class="inline"><sa-input-text [(text)]="component.id" [title]="'Property Name' "></sa-input-text></div>
    <button class="btn btn-primary" (click)="updateComponentProperty()">Update Component</button>
    <button class="btn btn-primary" style="float:right" (click)="showComponentPropertyModal = false">Cancel</button>
    <div class="spacer10"></div>
    <br>{{component | json}}
  </div>
</div>

<!-- Modal Lessonplan Property ----------------------------------------------->
<!-- moved into app-lessonplan component -->

<!-- Modal showLessonplanStepModal----------------------------------------------->
<!-- moved into app-lessonplan component -->

<!-- Modal showModifier----------------------------------------------->
<!-- moved into app-modifiers component -->
<!-- Modal showModifierPathInstancer----------------------------------------------->
<!-- moved into app-modifiers component -->
<!-- Modal showInteractivity----------------------------------------------->
<!-- moved into app-interactivities component -->
<!-- Modal showInteractivityGrass----------------------------------------------->
<!-- moved into app-interactivities component -->
<!-- Modal showInteractivityModalHandler----------------------------------------------->
<!-- moved into app-interactivities component -->
<!-- Modal showInteractivityInventory----------------------------------------------->
<!-- moved into app-interactivities component -->